// extracted by mini-css-extract-plugin
export default {"grid":"NQV1Fh","container":"oMWfWR"};